import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

export const useUpdateProfile = () => {
  const [openModal, setOpenModal] = useState(false);
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .patch(`${process.env.REACT_APP_BASE_URL}/user/profile`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (res) => {
        // @ts-ignore
        queryClient.invalidateQueries("PROFILE");
        setOpenModal(true);
      },
    }
  );

  return {
    openModal,
    setOpenModal,
    mutate,
    isLoading,
  };
};

export const useUpdateProfilePic = () => {
  const [openModal, setOpenModal] = useState(false);
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .patch(`${process.env.REACT_APP_BASE_URL}/user/profile/photo`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (res) => {
        // @ts-ignore
        queryClient.invalidateQueries("PROFILE");
        setOpenModal(true);
      },
    }
  );

  return {
    openModal,
    setOpenModal,
    mutate,
    isLoading,
  };
};
